<template>
  <div class="index">
    <!-- <div class="box"></div> -->
    <iframe style="height:90vh;border:none" width="100%" src="http://xfx.yunlansoft.com/index.html"></iframe>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
export default {
  data() {
    return {

    }
  },
  // 注册组件
  components: {

  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

  },
  methods: {

  }
}
</script>

<style scoped>
  .box{
    height:20px
  }


</style>



// WEBPACK FOOTER //
// src/views/vr/vr.vue